import React from 'react'

import Icon from '../../icon'

import { Container } from './styles'

import IProps from './props'

const LinkContact = ({
  to, icon, isPhone, label, target,
}: IProps) => (
  <Container to={to} isPhone={isPhone} target={`${target || ''}`}>
    <Icon name={icon} />
    {label}
    {isPhone && <Icon name="arrow-right" data-name="arrow-right" />}
  </Container>
)

LinkContact.defaultProps = {
  isPhone: false,
  target: '',
}

export default LinkContact
